import { createNumberMask } from 'text-mask-addons';
import { DateTime } from 'luxon';
import { stripWhitespace } from 'helpers';

const alphaNumeric = /[a-zA-Z0-9]/;

export const htmlFormat = {
  decode(input) {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  },
};

export const langFormat = {
  /** Return null if a = b, else return a */
  nullIf(a, b) {
    return a === b ? null : a;
  },
};

export const stringFormat = {
  stripWhitespace(value) {
    if (value && typeof value === 'string' && value !== '') {
      return value.replace(/ /g, '');
    } else {
      return value;
    }
  },
};

export const masks = {
  businessRegistration: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
  ],
  postalCode: [/\d/, /\d/, /\d/, /\d/],
  rsaId: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
  passport: Array.from(Array(13).keys()).map((i) => alphaNumeric),
  phoneNumber: ['+', '2', '7', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  phoneNumberSpaced: [
    '+',
    '2',
    '7',
    ' ',
    /[1-9]/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  year: [/[1-2]/, /[0-9]/, /\d/, /\d/],
  currencyAmount: createNumberMask({
    prefix: 'R ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ' ',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 9,
    allowNegative: false,
    allowLeadingZeroes: false,
    inputMode: 'numeric',
  }),
};

export const offersFormat = (offersData) =>
  offersData.matches.flatMap(
    ({ id, probability, companyLogoUrl, companyName, companyWebsiteUrl, liveScore }) => {
      const hasLiveOffer = liveScore && liveScore !== -2;
      const e2eLender = false;

      if (hasLiveOffer) {
        if (Array.isArray(liveScore.offers)) {
          return liveScore.offers.map((offerItem) => ({
            partnerId: id,
            probability,
            companyLogoUrl,
            companyName,
            companyWebsiteUrl,
            live: true,
            e2eLender,
            liveScore: offerItem,
          }));
        } else {
          return {
            partnerId: id,
            probability,
            companyLogoUrl,
            companyName,
            companyWebsiteUrl,
            live: true,
            e2eLender,
            liveScore,
          };
        }
      } else {
        return {
          partnerId: id,
          probability,
          companyLogoUrl,
          companyName,
          companyWebsiteUrl,
          live: false,
        };
      }
    },
  );

export const stripRandSymbolPrefix = (text) => (text ? text.toString().replace(/R/g, '') : text);

export const parseCurrency = (turnover) =>
  Number.parseFloat(stripWhitespace(stripRandSymbolPrefix(turnover)) || '0');

/**
 *
 * @param {string} startDate - the start date
 * @param {string} endDate - the end date
 * @param {string | Array} filter - which values to filter by
 * @returns {Object} returns the difference between the dates by the filter
 */
export const calcDateDiff = (startDate, endDate, filter) => {
  const start = DateTime.fromISO(startDate);
  const end = DateTime.fromISO(endDate);
  const dateDiff = end.diff(start, filter);
  return dateDiff.toObject();
};

/**
 *
 * @param {number} months - how many months to subtract from today
 * @returns {string} the resulting date as an ISO date (yyyy-MM-dd)
 */
export const isoDateMonthsAgo = (months) => DateTime.now().minus({ months }).toISODate();

export const formatCurrency = (number) => {
  if (!number) {
    return false;
  }
  const formatter = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    currencyDisplay: 'symbol',
  });

  return formatter.format(number);
};

export const generateUUID = () => {
  let d = Date.now();
  let d2 =
    (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
    if (d > 0) {
      r = Math.trunc((d + r) % 16);
      d = Math.floor(d / 16);
    } else {
      r = Math.trunc((d2 + r) % 16);
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};
